import React, {
    createContext, useReducer, useMemo, useEffect
} from 'react';
import { gql } from '@apollo/client';
import useLazyGetData from '../customHooks/useLazyGetData';
import Loading from '../components/Loading';


const GET_FARMS = gql`
   query Farms {
      farms {
         id
         location {
            lat
            lng
         }
         name
         user {
            id
         }
         farmColor
         timeZone
      }
   }
`;


const initialState = {
    farmList: [{ label: 'Loading... check later.', value: '' }],
    // An array of label & value pairs for select components.
    farms: [], // The array of farm objects with full properties.
};

const actions = {
    SET_FARM_LIST: 'SET_FARM_LIST',
    SET_FARMS: 'SET_FARMS',
};

function reducer(state, action) {
    switch (action.type) {
        case actions.SET_FARM_LIST:
            return { ...state, farmList: action.payload };
        case actions.SET_FARMS:
            return { ...state, farms: action.payload };
        default:
            return state;
    }
}

export const FarmsContext = createContext();

const FarmsContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState);

    const [getFarms, { data, error, loading }] = useLazyGetData(GET_FARMS, null, true);

    useEffect(() => {
        getFarms();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!loading && !error && data) {
            dispatch({ type: actions.SET_FARMS, payload: data });

            const farmsArray = [];
            data.forEach((singleFarm) => {
                farmsArray.push({ label: singleFarm.name, value: singleFarm.id });
            });
            dispatch({ type: actions.SET_FARM_LIST, payload: farmsArray });
        }
        else if (!loading && error) {
            dispatch({ type: actions.SET_FARM_LIST, payload: [{ label: 'Error on loading data!', value: null }] });
        }
    }, [data, error, loading]);

    const value = useMemo(() => ({
        farmList: state.farmList,
        farms: state.farms
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }), [state, dispatch]);

    return (
        <FarmsContext.Provider value={value}>
            {loading ? <Loading isFullPage /> :
                (error ? 'Error on loading Farms.' : children)}
        </FarmsContext.Provider>
    );
}

export default FarmsContextProvider;
